module.exports = __webpack_public_path__ + "static/media/Rolling-1s-200px.b800e9ba.svg";